module.exports = __webpack_public_path__ + "img/IMG_1458_L_WoodMatted.e9c99fef.jpg";